<template>
<div  style="padding:10px;">
<van-cell-group>
  <van-field v-model="wifiname" label="WIFI名称" placeholder="WIFI名称" />
</van-cell-group>
<van-cell-group>
  <van-field v-model="wifipasswd" label="WIFI密码" placeholder="WIFI密码" />
</van-cell-group>
<van-radio-group v-model="radio">
  <van-cell-group>
    <van-cell  value="WPA-PSK" clickable @click="radio = 'WPA-PSK'">
      <template #right-icon>
        <van-radio name="WPA-PSK" />
      </template>
    </van-cell>
   <!-- 
   <van-cell value="WPA-PSK2" clickable @click="radio = 'WPA-PSK2'">
      <template #right-icon>
        <van-radio name="WPA-PSK2" />
      </template>
    </van-cell>
    -->
  </van-cell-group>
</van-radio-group>

<van-cell-group>
 <van-cell value="" />
</van-cell-group>
<van-cell-group>
  <van-button type="info" size="large" @click="scanCode" >生成设置</van-button>
</van-cell-group>
<vue-qr  :text="qrcontent" :size="300"></vue-qr>
<van-cell-group  v-show="showText">
   <van-cell border=false>
   <div> 通过E精灵扫描以上二维码，扫码成功后，大约20到30s的时间，当听到三声“滴”的声响时，则WIFI设置成功。</div>
   </van-cell>
</van-cell-group>
</div>
</template>
<script>
import Vue from 'vue';
import { Field } from 'vant';
import vueQr from 'vue-qr'
import { Cell, CellGroup } from 'vant';
import { Button } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { Toast } from 'vant';

Vue.use(Toast);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Button);
Vue.use(Field);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(vueQr);
export default {
		name: 'wifiSet',
		data() {
			return {
        wifiname: '',
        qrcontent: '',
        wifipasswd:'',
        radio:'WPA-PSK',
        showText:false
      }
		},methods:{
        scanCode(){

          if(this.wifiname&&this.wifipasswd){

          var qrjson={};
          qrjson["SID"]=this.wifiname;
          qrjson["PSK"]=this.wifipasswd;
          qrjson["KEYMGMT"]=this.radio;
          this.qrcontent="WIFI="+JSON.stringify(qrjson);
          this.showText=true;

          }else{

            Toast('请正确输入WIFI名称与密码');

          }

          

        }

    },
   components: {
      vueQr
    }
    
}
</script>


// WEBPACK FOOTER //
// src/components/wifiSet.vue